import React, { useState, useEffect } from 'react';
import './App.css';

function Empleados() {
  const [empleados, setEmpleados] = useState([]);
  const [nombre, setNombre] = useState('');
  const [correo, setCorreo] = useState('');
  const [password, setPassword] = useState('');
  const [rol, setRol] = useState('empleado');
  const [cargo, setCargo] = useState('Peón');
  const [valorHora, setValorHora] = useState(''); // NUEVO: Estado para el dinero
  const [documento, setDocumento] = useState(null);
  
  const [documentoActual, setDocumentoActual] = useState(''); 
  const [idEditando, setIdEditando] = useState(null);

  useEffect(() => {
    fetchEmpleados();
  }, []);

  const fetchEmpleados = async () => {
    try {
      const res = await fetch('/api/empleados');
      const data = await res.json();
      setEmpleados(data);
    } catch (error) {
      console.error('Error cargando empleados', error);
    }
  };

  const limpiarFormulario = () => {
    setNombre(''); setCorreo(''); setPassword(''); setRol('empleado'); setCargo('Peón'); 
    setValorHora(''); // Limpiar el valor por hora
    setDocumento(null); setIdEditando(null); setDocumentoActual('');
    document.getElementById('archivo-doc').value = '';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const formData = new FormData();
    formData.append('nombre', nombre);
    formData.append('correo', correo);
    if (password) formData.append('password', password); 
    formData.append('rol', rol);
    formData.append('cargo', cargo);
    formData.append('valor_hora', valorHora); // Enviamos el valor por hora al servidor
    if (documento) formData.append('documento', documento);
    
    formData.append('documento_url_actual', documentoActual); 

    try {
      const url = idEditando ? `/api/empleados/${idEditando}` : '/api/empleados';
      const method = idEditando ? 'PUT' : 'POST';

      const res = await fetch(url, {
        method: method,
        body: formData 
      });

      if (res.ok) {
        alert(idEditando ? '¡Empleado actualizado exitosamente!' : '¡Empleado registrado exitosamente!');
        limpiarFormulario();
        fetchEmpleados();
      } else {
        alert('Error al procesar la solicitud. Verifique los datos.');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleEditar = (emp) => {
    setIdEditando(emp.id);
    setNombre(emp.nombre);
    setCorreo(emp.correo);
    setRol(emp.rol);
    setCargo(emp.cargo || 'Peón');
    setValorHora(emp.valor_hora || ''); // Cargamos el valor por hora al editar
    setDocumentoActual(emp.documento_url || ''); 
  };

  const handleEliminar = async (id, nombreEmp) => {
    const confirmacion1 = window.confirm(`ATENCIÓN: ¿Estás seguro de que deseas eliminar al empleado ${nombreEmp}?`);
    if (confirmacion1) {
      const confirmacion2 = window.confirm(`ACCIÓN IRREVERSIBLE. ¿Realmente confirmas borrar definitivamente todo el registro de ${nombreEmp} de la base de datos de ASPE?`);
      if (confirmacion2) {
        try {
          const res = await fetch(`/api/empleados/${id}`, { method: 'DELETE' });
          if (res.ok) {
            alert('Empleado eliminado del sistema.');
            fetchEmpleados();
          }
        } catch (error) {
          console.error('Error al eliminar', error);
        }
      }
    }
  };

  return (
    <div className="dashboard-pantalla">
      <header className="dashboard-header">
        <img src="/logo.png" alt="ASPE Logo" className="dashboard-logo" />
        <button onClick={() => window.location.href = '/dashboard'} className="btn-volver">Volver al Panel</button>
      </header>

      <main className="dashboard-main">
        <h2>👥 Gestión de Personal</h2>
        <p>Administre los accesos, cargos, tarifas por hora y documentación de su equipo.</p>
        
        <div className="empleados-container">
          <form className="empleados-form" onSubmit={handleSubmit}>
            <h3>{idEditando ? 'Modificar Empleado' : 'Agregar Nuevo Empleado'}</h3>
            <input type="text" placeholder="Nombre completo" value={nombre} onChange={e => setNombre(e.target.value)} required />
            <input type="email" placeholder="Correo electrónico" value={correo} onChange={e => setCorreo(e.target.value)} required />
            
            <input type="text" placeholder={idEditando ? "Dejar en blanco para no cambiar clave" : "Contraseña temporal"} value={password} onChange={e => setPassword(e.target.value)} required={!idEditando} />
            
            {/* Agrupamos Cargo y Valor Hora en una misma fila */}
            <div style={{ display: 'flex', gap: '10px' }}>
              <select style={{ flex: 1 }} value={cargo} onChange={e => setCargo(e.target.value)}>
                <option value="Peón">Peón</option>
                <option value="Medio Oficial">Medio Oficial</option>
                <option value="Oficial">Oficial</option>
                <option value="Técnico">Técnico Electricista</option>
                <option value="Ingeniero">Ingeniero</option>
                <option value="Administrativo">Administrativo</option>
              </select>

              <input 
                style={{ flex: 1 }} 
                type="number" 
                placeholder="Valor Hora ($ UYU)" 
                value={valorHora} 
                onChange={e => setValorHora(e.target.value)} 
                required 
              />
            </div>

            <select value={rol} onChange={e => setRol(e.target.value)}>
              <option value="empleado">Acceso: Empleado (Limitado)</option>
              <option value="admin">Acceso: Administrador (Total)</option>
            </select>

            <div className="input-archivo">
              <label>Foto de C.I. (Opcional):</label>
              <input id="archivo-doc" type="file" accept="image/*,application/pdf" onChange={e => setDocumento(e.target.files[0])} />
              {idEditando && documentoActual && <small style={{color: "green"}}>Ya tiene un documento subido. Sube uno nuevo solo si deseas reemplazarlo.</small>}
            </div>

            <div className="botones-form">
              <button type="submit" className="btn-primario">{idEditando ? 'Guardar Cambios' : 'Registrar Empleado'}</button>
              {idEditando && <button type="button" className="btn-peligro" onClick={limpiarFormulario}>Cancelar</button>}
            </div>
          </form>

          <div className="empleados-lista">
            <h3>Nómina Actual</h3>
            <table className="tabla-aspe">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Cargo & Tarifa</th>
                  <th>Permisos</th>
                  <th>Documento</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {empleados.map(emp => (
                  <tr key={emp.id}>
                    <td><strong>{emp.nombre}</strong><br/><small>{emp.correo}</small></td>
                    <td>
                      {emp.cargo || 'No asignado'}<br/>
                      <small style={{color: '#28a745', fontWeight: 'bold'}}>$ {emp.valor_hora} / hr</small>
                    </td>
                    <td><span className={`badge-${emp.rol}`}>{emp.rol.toUpperCase()}</span></td>
                    <td>
                      {emp.documento_url ? (
                        <a href={emp.documento_url} target="_blank" rel="noopener noreferrer" className="link-doc">Ver Foto</a>
                      ) : 'Falta'}
                    </td>
                    <td className="celda-acciones">
                      <button onClick={() => handleEditar(emp)} className="btn-accion btn-editar">✏️ Editar</button>
                      <button onClick={() => handleEliminar(emp.id, emp.nombre)} className="btn-accion btn-borrar">🗑️ Borrar</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Empleados;